(function () {
  var LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
  var LEAFLET_JS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
  var LEAFLET_CSS_INTEGRITY = "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=";
  var LEAFLET_JS_INTEGRITY = "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=";
  var UNIT_ORDER = ["sqft", "acre", "sqm"];
  var METERS_TO_SQFT = 10.76391041671;
  var METERS_TO_ACRE = 0.00024710538146717;

  var leafletPromise;

  function loadStylesheet(url) {
    if (document.querySelector('link[href="' + url + '"]')) {
      return;
    }

    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    link.integrity = LEAFLET_CSS_INTEGRITY;
    link.crossOrigin = "";
    document.head.appendChild(link);
  }

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + url + '"]');

      if (existing) {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      var script = document.createElement("script");
      script.src = url;
      script.defer = true;
      script.integrity = LEAFLET_JS_INTEGRITY;
      script.crossOrigin = "";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadLeaflet() {
    if (window.L && window.L.map) {
      return Promise.resolve(window.L);
    }

    if (!leafletPromise) {
      loadStylesheet(LEAFLET_CSS);
      leafletPromise = loadScript(LEAFLET_JS).then(function () {
        return window.L;
      });
    }

    return leafletPromise;
  }

  function parseConfig(root) {
    var configNode = root.querySelector("[data-lawn-measure-config]");

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      return {};
    }
  }

  function getNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function setStatus(root, message) {
    var status = root.querySelector("[data-status]");
    if (status) {
      status.textContent = message || "";
    }
  }

  function createVertexIcon(isClosePoint) {
    return window.L.divIcon({
      className: "",
      iconSize: [18, 18],
      iconAnchor: [9, 9],
      html: '<span class="lawn-measure__vertex' + (isClosePoint ? " lawn-measure__vertex--close" : "") + '"></span>',
    });
  }

  function createLocatorIcon() {
    return window.L.divIcon({
      className: "",
      iconSize: [54, 54],
      iconAnchor: [27, 27],
      html: '<span class="lawn-measure__locator"><span class="lawn-measure__locator-dot"></span></span>',
    });
  }

  function createAreaIcon(value, unitLabel) {
    return window.L.divIcon({
      className: "lawn-measure__draw-label",
      iconSize: [120, 44],
      iconAnchor: [60, 22],
      html: "<span>" + value + "</span><br><span>" + unitLabel + "</span>",
    });
  }

  function geodesicArea(latLngs) {
    var points = latLngs.map(function (latLng) {
      return {
        lat: (latLng.lat * Math.PI) / 180,
        lng: (latLng.lng * Math.PI) / 180,
      };
    });
    var radius = 6378137;
    var area = 0;

    if (points.length < 3) {
      return 0;
    }

    for (var index = 0; index < points.length; index += 1) {
      var point = points[index];
      var nextPoint = points[(index + 1) % points.length];
      area += (nextPoint.lng - point.lng) * (2 + Math.sin(point.lat) + Math.sin(nextPoint.lat));
    }

    return Math.abs((area * radius * radius) / 2);
  }

  function formatArea(squareMeters, unit) {
    if (unit === "acre") {
      return {
        value: formatNumber(squareMeters * METERS_TO_ACRE, 2),
        unitValue: squareMeters * METERS_TO_ACRE,
      };
    }

    if (unit === "sqm") {
      return {
        value: formatNumber(squareMeters, squareMeters >= 100 ? 0 : 1),
        unitValue: squareMeters,
      };
    }

    return {
      value: formatNumber(squareMeters * METERS_TO_SQFT, 0),
      unitValue: squareMeters * METERS_TO_SQFT,
    };
  }

  function formatNumber(value, decimals) {
    return new Intl.NumberFormat(undefined, {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals > 0 && value < 10 ? decimals : 0,
    }).format(value);
  }

  function getCentroid(latLngs) {
    var lat = 0;
    var lng = 0;

    latLngs.forEach(function (latLng) {
      lat += latLng.lat;
      lng += latLng.lng;
    });

    return window.L.latLng(lat / latLngs.length, lng / latLngs.length);
  }

  function getUnitLabel(config, unit) {
    var labels = config.labels || {};

    if (unit === "acre") {
      return labels.acre || "Acre";
    }

    if (unit === "sqm") {
      return labels.squareMeters || "Square Meters";
    }

    return labels.squareFeet || "Square Feet";
  }

  function updateUnit(root, config, unit) {
    var node = root.querySelector("[data-current-unit]");
    if (node) {
      node.textContent = getUnitLabel(config, unit);
    }
  }

  function initializeMeasure(root) {
    if (root.dataset.lawnMeasureReady === "true") {
      return;
    }

    root.dataset.lawnMeasureReady = "true";

    var config = parseConfig(root);
    var mapNode = root.querySelector("[data-map]");
    var searchForm = root.querySelector("[data-search-form]");
    var searchInput = root.querySelector("[data-address-input]");
    var drawing = false;
    var currentPoints = [];
    var currentMarkers = [];
    var savedShapes = [];
    var tempLine;
    var locatorMarker;
    var currentUnit = UNIT_ORDER.indexOf(config.defaultUnit) >= 0 ? config.defaultUnit : "sqft";
    var labels = config.labels || {};

    updateUnit(root, config, currentUnit);

    loadLeaflet()
      .then(function (L) {
        var map = L.map(mapNode, {
          zoomControl: true,
          scrollWheelZoom: true,
        }).setView(
          [getNumber(config.initialLat, 33.9192), getNumber(config.initialLng, -118.4165)],
          getNumber(config.initialZoom, 18)
        );

        L.tileLayer(config.tileUrl || "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
          attribution: config.tileAttribution || "Tiles &copy; Esri",
          maxNativeZoom: 19,
          maxZoom: 21,
        }).addTo(map);

        setTimeout(function () {
          map.invalidateSize();
        }, 80);

        root.lawnMeasureMap = map;

        function refreshShapes() {
          savedShapes.forEach(function (shape) {
            var formatted = formatArea(shape.squareMeters, currentUnit);
            var unitLabel = getUnitLabel(config, currentUnit);
            shape.label.setIcon(createAreaIcon(formatted.value, unitLabel));
            shape.polygon.bindTooltip(formatted.value + " " + unitLabel, {
              sticky: true,
              direction: "top",
            });
          });
        }

        function clearDraft() {
          currentPoints = [];
          currentMarkers.forEach(function (marker) {
            map.removeLayer(marker);
          });
          currentMarkers = [];

          if (tempLine) {
            map.removeLayer(tempLine);
            tempLine = null;
          }

          drawing = false;
          var drawButton = root.querySelector('[data-action="draw"]');
          if (drawButton) {
            drawButton.setAttribute("aria-pressed", "false");
          }

          setStatus(root, labels.ready || "");
        }

        function updateDraftLine() {
          if (tempLine) {
            map.removeLayer(tempLine);
          }

          if (currentPoints.length > 1) {
            tempLine = L.polyline(currentPoints, {
              color: "#2f86f6",
              weight: 4,
              opacity: 0.95,
              dashArray: "8 8",
            }).addTo(map);
          }
        }

        function completePolygon() {
          if (currentPoints.length < 3) {
            setStatus(root, labels.closePolygon || "");
            return;
          }

          var points = currentPoints.slice();
          var polygon = L.polygon(points, {
            color: "#2f86f6",
            weight: 4,
            fillColor: "#8f96a3",
            fillOpacity: 0.45,
          }).addTo(map);
          var squareMeters = geodesicArea(points);
          var formatted = formatArea(squareMeters, currentUnit);
          var unitLabel = getUnitLabel(config, currentUnit);
          var label = L.marker(getCentroid(points), {
            interactive: false,
            icon: createAreaIcon(formatted.value, unitLabel),
          }).addTo(map);

          polygon.bindTooltip(formatted.value + " " + unitLabel, {
            sticky: true,
            direction: "top",
          });

          savedShapes.push({
            polygon: polygon,
            label: label,
            squareMeters: squareMeters,
          });

          clearDraft();
          setStatus(root, formatted.value + " " + unitLabel);
        }

        function addPoint(latLng) {
          if (!drawing) {
            return;
          }

          var isFirstPoint = currentPoints.length === 0;
          var marker = L.marker(latLng, {
            icon: createVertexIcon(false),
            zIndexOffset: 700,
          }).addTo(map);

          marker.on("click", function (event) {
            window.L.DomEvent.stopPropagation(event);

            if (currentPoints.length >= 3 && marker === currentMarkers[0]) {
              completePolygon();
            }
          });

          currentPoints.push(latLng);
          currentMarkers.push(marker);

          if (isFirstPoint) {
            marker.setIcon(createVertexIcon(true));
          }

          updateDraftLine();

          if (currentPoints.length >= 3) {
            setStatus(root, labels.closePolygon || "");
          }
        }

        function startDrawing() {
          clearDraft();
          drawing = true;
          var drawButton = root.querySelector('[data-action="draw"]');
          if (drawButton) {
            drawButton.setAttribute("aria-pressed", "true");
          }
          setStatus(root, labels.drawing || "");
        }

        map.on("click", function (event) {
          addPoint(event.latlng);
        });

        root.addEventListener("click", function (event) {
          var actionButton = event.target.closest("[data-action]");

          if (!actionButton) {
            return;
          }

          var action = actionButton.getAttribute("data-action");

          if (action === "draw") {
            startDrawing();
          }

          if (action === "discard") {
            clearDraft();
          }

          if (action === "clear") {
            clearDraft();
            savedShapes.forEach(function (shape) {
              map.removeLayer(shape.polygon);
              map.removeLayer(shape.label);
            });
            savedShapes = [];
            setStatus(root, labels.ready || "");
          }

          if (action === "unit") {
            var nextIndex = (UNIT_ORDER.indexOf(currentUnit) + 1) % UNIT_ORDER.length;
            currentUnit = UNIT_ORDER[nextIndex];
            updateUnit(root, config, currentUnit);
            refreshShapes();
          }

        });

        if (searchForm && searchInput) {
          searchForm.addEventListener("submit", function (event) {
            event.preventDefault();
            searchAddress(map, config, root, searchInput.value).then(function (latLng) {
              if (!latLng) {
                return;
              }

              if (locatorMarker) {
                map.removeLayer(locatorMarker);
              }

              locatorMarker = L.marker(latLng, {
                icon: createLocatorIcon(),
                interactive: false,
                zIndexOffset: 900,
              }).addTo(map);
              map.setView(latLng, Math.max(map.getZoom(), 19));
              setStatus(root, labels.ready || "");
            });
          });
        }
      })
      .catch(function () {
        setStatus(root, "Map failed to load.");
      });
  }

  function searchAddress(map, config, root, query) {
    var labels = config.labels || {};
    var value = String(query || "").trim();

    if (!value) {
      return Promise.resolve(null);
    }

    setStatus(root, labels.searching || "");

    var endpoint = config.geocodeEndpoint || "https://nominatim.openstreetmap.org/search";
    var url = new URL(endpoint);
    url.searchParams.set("format", "json");
    url.searchParams.set("limit", "1");
    url.searchParams.set("q", value);

    return fetch(url.toString(), {
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Geocode request failed");
        }

        return response.json();
      })
      .then(function (results) {
        if (!Array.isArray(results) || !results.length) {
          setStatus(root, labels.searchEmpty || "");
          return null;
        }

        return window.L.latLng(Number(results[0].lat), Number(results[0].lon));
      })
      .catch(function () {
        setStatus(root, labels.searchError || "");
        return null;
      });
  }

  function boot() {
    document.querySelectorAll("[data-lawn-measure]").forEach(initializeMeasure);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector("[data-lawn-measure]")) {
      initializeMeasure(event.target.querySelector("[data-lawn-measure]"));
    }
  });

  document.addEventListener("lawn-area-measure:modal-open", function (event) {
    var modal = event.detail && event.detail.modal;
    if (!modal) {
      return;
    }

    modal.querySelectorAll("[data-lawn-measure]").forEach(function (root) {
      initializeMeasure(root);
      setTimeout(function () {
        if (root.lawnMeasureMap) {
          root.lawnMeasureMap.invalidateSize();
        }
      }, 120);
    });
  });
})();
